import styles from './RootPageCard.module.scss';
import { ReactElement, ReactNode } from 'react';
import { VdsCard } from '@volt/volt-extended-components-react';

type RootPageCardProps = {
  children?: ReactNode;
  subHeading?: string;
  subText?: string;
  fields?: ReactNode;
};

export function RootPageCard({
  children,
  subHeading,
  subText,
  fields,
}: RootPageCardProps): ReactElement {
  return (
    <VdsCard padding={'spacing-00'}>
      <div className={styles.card}>
        {subHeading && <span className={styles.subHeading}>{subHeading}</span>}
        {subText && <span className={styles.subText}>{subText}</span>}
        {fields && <div className={styles.fields}>{fields}</div>}
        {children}
      </div>
    </VdsCard>
  );
}

export default RootPageCard;
